import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AgentResponseLayout from "../../../components/agent/AgentResponseLayout";
import SelectInput from "../../../components/forms/SelectInput";
import NotesField from "../../../components/forms/NotesField";
import { useAgentResponse } from "../../../js/hooks/useAgentResponse";
import { RECOMMENDATION_OPTIONS } from "../../../js/utils/agentResponseOptions";

export default function AgentResponseSummary() {
  const navigate = useNavigate();
  const { response, saveSection, goBack, desk } = useAgentResponse("summary");
  const saved = response?.summary || {};
  const [form, setForm] = useState(null);
  const current = form || saved;

  function update(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...(prev || saved), [name]: value }));
  }

  async function handleContinue() {
    await saveSection(current);
    navigate(response?.buyerId ? desk.client(response.buyerId) : desk.responses);
  }

  if (!response) {
    return (
      <AgentResponseLayout title="Agent Summary" onBack={goBack} onContinue={() => {}}>
        <p>Loading response…</p>
      </AgentResponseLayout>
    );
  }

  return (
    <AgentResponseLayout
      response={response}
      sectionKey="summary"
      title="Agent Summary"
      lead="Your professional read: how this home fits the buyer, what to love, what to watch, and what to do next."
      onBack={goBack}
      onContinue={handleContinue}
      continueLabel="Save summary"
    >
      <section className="checklist-section">
        <h2>Fit for This Buyer</h2>
        <SelectInput
          label="Recommendation"
          name="recommendation"
          value={current.recommendation}
          onChange={update}
          options={RECOMMENDATION_OPTIONS}
        />
        <NotesField
          label="Match to buyer checklist"
          name="matchToBuyer"
          value={current.matchToBuyer}
          onChange={update}
          placeholder="Where this listing hits their must-haves, and where it stretches them."
        />
        <NotesField
          label="Strengths"
          name="strengths"
          value={current.strengths}
          onChange={update}
          rows={3}
          placeholder="Light, lot, kitchen, location, condition — the talking points."
        />
        <NotesField
          label="Concerns"
          name="concerns"
          value={current.concerns}
          onChange={update}
          rows={3}
          placeholder="Deal-breakers, inspection risk, or rooms that will need a conversation."
        />
        <NotesField
          label="Next steps"
          name="nextSteps"
          value={current.nextSteps}
          onChange={update}
          rows={3}
          placeholder="Second showing, contractor walk, write tonight, or keep looking."
        />
        <NotesField
          label="Showing notes"
          name="showingNotes"
          value={current.showingNotes}
          onChange={update}
          placeholder="Access, alarm, tenants, or how the buyer reacted on the tour."
        />
      </section>
    </AgentResponseLayout>
  );
}
